module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/img-photo-studio-western-dress-65ddca39cb414f4cc45a0c86525d6153.png";